import { NgModule } from '@angular/core';
import { NcInformationDialogComponent } from './nc-dialog-information/nc-information-dialog.component';
import {TranslateModule} from '@ngx-translate/core';
import {NcConfirmationDialogModule} from 'nc-confirmation-dialog';

@NgModule({
  declarations: [NcInformationDialogComponent],
  imports: [
    TranslateModule,
    NcConfirmationDialogModule
  ],
  exports: [NcInformationDialogComponent]
})
export class NcInformationDialogModule { }
